var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle00ASelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 48",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  d: "M1 2.5A1.5 1.5 0 0 1 2.5 1h23A1.5 1.5 0 0 1 27 2.5v43a1.5 1.5 0 0 1-1.5 1.5h-23A1.5 1.5 0 0 1 1 45.5v-43Z"
})));
SvgRectangle00ASelected.viewBox = '0 0 28 48';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle00ASelected);
export default ForwardRef;